import { useEffect, useMemo, useState } from "react";
import {
  extractGpsSegments,
  hideRawGpsInLabel,
  mapsUrl,
  resolvePunchLocationText,
} from "../../utils/reverseGeocode";
import "./PunchLocationLabel.css";

export default function PunchLocationLabel({ location, fallback = "—" }) {
  const raw = String(location || "").trim();
  const [text, setText] = useState(raw);

  const originalSegments = useMemo(() => extractGpsSegments(raw), [raw]);

  useEffect(() => {
    setText(raw);
    if (!raw || !/GPS:/i.test(raw)) return undefined;
    let cancelled = false;
    resolvePunchLocationText(raw).then((resolved) => {
      if (!cancelled && resolved) setText(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [raw]);

  if (!raw) return fallback;

  const displaySegments = extractGpsSegments(text);

  return (
    <div className="punch-location-label">
      {displaySegments.map((segment, index) => {
        const original = originalSegments[index] || {};
        const href = mapsUrl(original.latitude, original.longitude);
        return (
          <div key={`${segment.label}-${index}`} className="punch-location-line">
            <span>{hideRawGpsInLabel(segment.label) || fallback}</span>
            {href ? (
              <a
                className="punch-location-map"
                href={href}
                target="_blank"
                rel="noreferrer"
              >
                الخريطة
              </a>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
